import { useState } from "react";
import { Modal } from "react-bootstrap";
import { createRoot } from 'react-dom/client';
import { KTSVG } from "../../_metronic/helpers";

/**
 * ConfirmPop component for rendering a customizable confirmation modal.
 * - Displays title, text, icon, and configurable buttons (Confirm, Cancel, OK).
 * - Calls onResolve callback with user response.
 */
const ConfirmPop = ({ data, onResolve }) => {
    const [isOpen, setIsOpen] = useState(true);

    const handleConfirm = () => {
        setIsOpen(false);
        onResolve(true);
    };

    const handleCancel = () => {
        setIsOpen(false);
        onResolve(false);
    };

    return (
        <Modal show={isOpen} onHide={handleCancel} backdrop="static" centered>
            <Modal.Body>
                <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                    {['warning', 'error', 'success'].includes(data?.icon) && (
                        <KTSVG
                            path="/media/icons/duotune/general/gen044.svg"
                            className="svg-icon svg-icon-4x svg-icon-warning me-5"
                        />
                    )}
                    <div className="fs-4 fw-semibolder">{data?.title}</div>
                    <div className="text-gray-700 fs-4 fw-semibold">{data?.text}</div>
                </div>
                <div className="card-footer py-2 mt-4">
                    <div className="d-flex justify-content-center">
                        {data.buttons.includes('Cancel') &&
                            <button
                                type="button"
                                className="btn btn-secondary me-4"
                                onClick={handleCancel}
                            >
                                <span className="indicator-label">Cancel</span>
                            </button>
                        }
                        {(data.buttons.includes('Confirm') || data.buttons.includes('OK')) &&
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleConfirm}
                            >
                                <span className="indicator-label">
                                    {data.buttons.includes('OK') ? 'OK' : 'Confirm'}
                                </span>
                            </button>
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

/**
 * confirmAlert function for showing a confirmation modal and returning a Promise.
 * - Dynamically mounts ConfirmPop modal to the DOM and resolves with user response.
 * - Cleans up modal after user action.
 */
const confirmAlert = (data) => {
    return new Promise((resolve) => {
        const modalRoot = document.createElement("div");
        modalRoot.id = "confirm-modal-root";
        document.body.appendChild(modalRoot);

        const root = createRoot(modalRoot); // Create root for this modal

        const cleanup = () => {
            root.unmount(); // Unmount React tree
            document.body.removeChild(modalRoot); // Remove div
        };

        root.render(
            <ConfirmPop
                data={data}
                onResolve={(result) => {
                    resolve(result);
                    cleanup();
                }}
            />
        );
    });
};

export default confirmAlert;
